import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend,
    LineController,
    BarController,
    PieController,
    DoughnutController,
    Filler
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Register all necessary components globally
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend,
    LineController,
    BarController,
    PieController,
    DoughnutController,
    Filler,
    ChartDataLabels
);

console.log('Chart.js components registered globally');
